import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  id: "login-box",
  class: "card"
}
const _hoisted_4 = { class: "card-content" }
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_input = _resolveComponent("b-input")!
  const _component_b_field = _resolveComponent("b-field")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_ValidationObserver = _resolveComponent("ValidationObserver")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[13] || (_cache[13] = _createElementVNode("h1", {
        id: "title",
        class: "title has-text-centered"
      }, " Vue Bulma with Firebase Auth ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[12] || (_cache[12] = _createElementVNode("h1", { class: "title has-text-centered" }, "Login", -1)),
          _createVNode(_component_ValidationObserver, null, {
            default: _withCtx(({ handleSubmit }) => [
              _createElementVNode("form", {
                onSubmit: _withModifiers(($event: any) => (handleSubmit(_ctx.login)), ["prevent"])
              }, [
                _createVNode(_component_ValidationProvider, {
                  name: "email",
                  rules: "required|email"
                }, {
                  default: _withCtx(({ errors, failed, passed }) => [
                    _createVNode(_component_b_field, {
                      label: "Email",
                      type: { 'is-danger': failed, 'is-success': passed },
                      message: errors[0]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_input, {
                          type: "email",
                          modelValue: _ctx.email,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                          maxlength: "30"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["type", "message"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ValidationProvider, {
                  name: "password",
                  rules: "required"
                }, {
                  default: _withCtx(({ errors, failed, passed }) => [
                    _createVNode(_component_b_field, {
                      label: "Password",
                      type: { 'is-danger': failed, 'is-success': passed },
                      message: errors[0]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_input, {
                          type: "password",
                          modelValue: _ctx.password,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                          "password-reveal": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["type", "message"])
                  ]),
                  _: 1
                }),
                _cache[6] || (_cache[6] = _createElementVNode("section", { class: "section" }, [
                  _createElementVNode("div", { class: "content has-text-centered" }, [
                    _createElementVNode("button", { class: "button is-primary" }, "Login")
                  ])
                ], -1))
              ], 40, _hoisted_5)
            ]),
            _: 1
          }),
          _createElementVNode("section", _hoisted_6, [
            _cache[11] || (_cache[11] = _createElementVNode("h4", { class: "subtitle" }, "Another Login Method", -1)),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_b_button, {
                "icon-left": "google",
                "icon-pack": "fab",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loginWithGoogle()))
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("Google", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_b_button, {
                "icon-left": "github",
                "icon-pack": "fab",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loginWithGithub()))
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("Github", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_b_button, {
                "icon-left": "facebook",
                "icon-pack": "fab",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loginWithFacebook()))
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("Facebook", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_b_button, {
                "icon-left": "twitter",
                "icon-pack": "fab",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loginWithTwitter()))
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("Twitter", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}